export default __webpack_public_path__ + "static/media/instagram.9346f58c.svg";